import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence, useScroll, useTransform } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
import { Logo } from './Logo';
export function Nav() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const {
    scrollY
  } = useScroll();
  const backdropBlur = useTransform(scrollY, [0, 100], [0, 20]);
  const backgroundColor = useTransform(scrollY, [0, 100], ['rgba(13, 22, 40, 0)', 'rgba(13, 22, 40, 0.96)']);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Labels sluiten aan op de kopteksten van de secties waar ze heen wijzen.
  const links = [{
    label: 'Hoe het werkt',
    href: '#hoe'
  }, {
    label: 'Voor wie',
    href: '#voor-wie'
  }, {
    label: 'Wat je krijgt',
    href: '#bewijs'
  }];
  return <motion.nav style={{
    backgroundColor,
    backdropFilter: `blur(${backdropBlur}px)`
  }} className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'border-b border-white/5' : ''}`} data-id="element-266" data-mp="1y5ow5vcw37oe">
      <div className="max-w-[1200px] mx-auto px-6 h-20 flex items-center justify-between" data-id="element-267" data-mp="1p5scy999r10q">
        <a href="#" className="focus:outline-none" aria-label="CorePrint, naar boven" data-id="element-268" data-mp="1k7h1xv78mkgx">
          <Logo data-id="element-269" data-mp="2hsw9dpuaq70w" />
        </a>

        {/* Desktop */}
        <div className="hidden md:flex items-center gap-10" data-id="element-270" data-mp="2hvqy3tkcee04">
          {links.map(link => <a key={link.href} href={link.href} className="relative text-[0.95rem] font-medium text-white/70 hover:text-white transition-colors" data-id="element-271" data-mp="2cx79tmia0q4l">
              {link.label}
            </a>)}
          <a href="#gesprek" className="inline-flex items-center gap-2 bg-brand-primary text-white font-semibold text-[0.95rem] px-6 py-3 rounded-lg hover:opacity-90 transition-opacity duration-200" data-id="element-272" data-mp="30l7abe5e3uwd">
            Plan een gesprek
          </a>
        </div>

        <button className="md:hidden p-2 text-white" onClick={() => setIsOpen(!isOpen)} aria-label={isOpen ? 'Menu sluiten' : 'Menu openen'} aria-expanded={isOpen} data-id="element-273" data-mp="xwp5xlbd9szj">
          {isOpen ? <XIcon size={24} data-id="element-274" data-mp="p3lwdo3ue0a6" /> : <MenuIcon size={24} data-id="element-275" data-mp="p33ry4710fr6" />}
        </button>
      </div>

      <AnimatePresence data-id="element-276" data-mp="a7eewvjtjcyl">
        {isOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="md:hidden bg-[#0D1628]/98 backdrop-blur-xl border-b border-white/5 overflow-hidden" data-id="element-277" data-mp="f794mvruxwi2">
            <div className="flex flex-col px-6 py-6 gap-5" data-id="element-278" data-mp="1vm1xa3stub4g">
              {links.map(link => <a key={link.label} href={link.href} className="text-white/80 font-medium text-lg hover:text-white transition-colors" onClick={() => setIsOpen(false)} data-id="element-279" data-mp="20k3iau9tckik">
                  {link.label}
                </a>)}
              <a href="#gesprek" className="inline-flex items-center justify-center w-full bg-brand-primary text-white font-semibold px-6 py-4 rounded-lg" onClick={() => setIsOpen(false)} data-id="element-280" data-mp="2jiotokddg188">
                Plan een gesprek
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </motion.nav>;
}